import { InjectionToken } from '@angular/core';

export const COMPONENT_DATA = new InjectionToken('COMPONENT_DATA');
export const COMPONENT_DATA_PASSED = new InjectionToken('COMPONENT_DATA_PASSED');